import { useMemo } from "react";
import { datetime } from "../../../../util/library/datetime";
import { DELIVERY_TYPE, deliveryType, dischargingModeName, STEP_STATUS } from "../../../../util/varibles/constants";
import { IDischarge } from "./_Discharging";

interface IProps {
    data: IDischarge
    disabled?: boolean
    onStart?: () => void
    onFinish?: () => void
}

export default function DeliveryType({ data, disabled = false, onStart, onFinish }: IProps) {
    const { real_start_time, real_finish_time, name } = data;


    const status = useMemo(() => {
        if (real_finish_time) {
            const prefix = dischargingModeName[STEP_STATUS.COMPLETED];
            const suffix = name.indexOf(deliveryType[DELIVERY_TYPE.DIRECT].name) === -1 ? 'into' : '';
            return <div className="flex flex-col items-center gap-1">
                <div className="text-comment text-[14px]">{datetime(real_start_time).format('HH:mm')}</div>
                <div className="text-[14px]">{prefix} {suffix} {name}</div>
                <div className="text-comment text-[14px]">{datetime(real_finish_time).format('HH:mm')}</div>
            </div>
        }
        if (real_start_time) {
            const prefix = dischargingModeName[STEP_STATUS.STARTED];
            const hoverClass = onFinish && !disabled ? 'cursor-pointer' : 'cursor-default'
            return <div className="flex flex-col items-center gap-1">
                <div className="text-comment text-[14px]">{datetime(real_start_time).format('HH:mm')}</div>
                <div
                    className={`text-center text-[14px] leading-normal px-[16px] py-[5px] bg-[var(--colorHover)] rounded-[30px] border border-[var(--colorActive)] transition-all duration-300 hover:text-[var(--colorActive)] ${hoverClass}`}
                    onClick={disabled ? undefined : onFinish}
                >
                    {prefix} into <br /> {name}
                </div>
            </div>
        }
        const prefix = dischargingModeName[STEP_STATUS.NOT_START];
        const hoverClass = onStart && !disabled ? 'cursor-pointer' : 'cursor-default'
        return <div
            className={`${disabled ? "text-comment" : "link"} text-[14px] ${hoverClass}`}
            onClick={disabled ? undefined : onStart}
        >
            {prefix} {name}
        </div>

    }, [disabled, real_finish_time, real_start_time, onStart, name, onFinish])

    return <div className={`flex justify-center py-[20px] px-[10px] ${disabled ? "opacity-50" : ""}`}>
        <div className="flex flex-col items-center">
            {status}
        </div>
    </div>
}
